/**
 * 이벤트 이름 허용 목록 (명세 v1.3 각 장 · 10장 지표, 귀인도감 trackEvents.js 와 같은 자리).
 * 서버(services/events.js)와 화면이 같이 읽습니다. 모르는 이름은 저장하지 않습니다.
 * 이름은 snake_case. 대화 원문은 props 에 넣지 않습니다.
 */
export const EVENT_NAMES = [
    // C-9 응답 속도
    'room_turn_timing',
    // C-28 오래된 답 막기 · 입력 중 대기 (SPEC_CHANGE_v1.3 22.6, D57)
    'stale_dropped',
    'compose_pause',
    'compose_resume',
    // C-10 이모 수첩
    'memo_saved_shown',
    'memo_open',
    'memo_edit',
    'memo_delete',
    'memo_blocked',
    'loop_followup_shown',
    'loop_followup_answered',
    // C-11 별채 첫 판
    'first_annex_scene',
    'first_annex_reply',
    // 어드민 품질 검수 자동 지표 (D41): 규칙 검사에 걸려 다시 만든 답
    'reply_rule_check',
    // C-17 이모의 사주 곁들이기
    'saju_aside_used',
    'saju_aside_skipped',
    'saju_aside_off',
    'room_saju_ask',
    // C-19 지식의 경계와 성장 (D49)
    'knowledge_gap_logged',
    // C-19c 지식 성장 · 돌아가기 (D62)
    'knowledge_card_approved',
    'knowledge_followup_shown',
    'knowledge_followup_answered',
    'fabrication_blocked',
    'safety_line_added',
    // 은별의 별 곁들이기 차례 (scent_and_stars.md 7장, D49)
    'star_aside_used',
    'star_aside_skipped',
    // C-18 은별의 하늘 읽기 (D65)
    'star_first_reading',
    'star_consult',
    'prophecy_made',
    'prophecy_scored',
    'star_compat_tossed',
    // C-20a 멤버끼리 주고받기 (SPEC_CHANGE_v1.3 15.7 · 22.3, D66)
    'turn_shape',
    'afterglow_shown',
    'afterglow_cancelled',
    'late_join_shown',
    'member_loop_opened',
    'member_loop_answered',
    'member_loop_closed',
    'second_line_dropped',
    'rest_chip_shown',
    'rest_chip_tap',
    // C-20b 돌아왔을 때 보이는 것 (SPEC_CHANGE_v1.3 15.8, D67)
    'last_seen_line_shown',
    'about_user_seen',
    'afterglow_toggle',
    // C-25 화제 던지기 (SPEC_CHANGE_v1.3 20장, D68)
    'topic_nudge_shown',
    'topic_nudge_received',
    'topic_nudge_passed',
    'topic_nudge_toggle',
    // C-20c 조용한 리액션 (SPEC_CHANGE_v1.3 22.4, D70)
    'quiet_reaction_shown',
    // C-30a 대체 말 차단 (SPEC_CHANGE_v1.3 24.2, D72)
    'reply_delay_line',
    'reply_all_failed',
    // C-29 대화 칩 · @ 멘션 (SPEC_CHANGE_v1.3 23.8, 시안 12, D74)
    'chip_shown',
    'chip_tap',
    'chip_dismissed',
    'chip_stale',
    'mention_open',
    'mention_pick',
    'message_send',
    // C-21 첫 방문 2막 장면 · 첫 주 이야기 (SPEC_CHANGE_v1.3 16.6, D76)
    'annex_scene_choice',
    'member_card_open',
    'welcome_step_shown',
    'welcome_step_answered',
    'welcome_step_skipped',
    'welcome_week_done',
    // C-31 이모 수첩에 단골이 직접 적기 (SPEC_CHANGE_v1.3 25.5, 시안 13, D75)
    'note_add_open',
    'note_add',
    'note_first_used',
    'note_schedule_asked',
    // 들은 얘기(C-13 · DEV-14): 꺼냄 { member, story, via } · 저녁 부르기 { member, story } · 프로필에서 다시 봄 { member, story }
    'deep_story_shown',
    'deep_story_called',
    'deep_story_reopen',
    // 1막 카운터 (SPEC_CHANGE_v1.3 16.6, D53)
    'tea_line_shown',
    'ledger_offer_shown',
    'birth_ask_shown',
    // 계정 (시안 06 M2 · M3)
    'account_logout',
    'account_delete',
    // 소셜 로그인 (D108). props 는 { provider } 만
    'account_signup',
    'account_login',
    // 가입 연령 · 청소년 쉬어 가기 안내 (DEV-07z · D99, 성인 전용 D115 뒤 쉬어 가기는 꺼짐). 연령 미달 막힘은 단골 연결 없이
    'join_under_age',
    'youth_rest_notice',
    // 이야기 아크 · 작가실 (DEV-10 · D104)
    'story_day',
    'story_item_published',
    'writers_queue_review',
    // 화면 이벤트 (명세 v1.3 10장: D1 · 하루 사용 시간 · 수첩 연 비율 · 위기 대비 안내 노출, D44)
    'app_open',
    'app_active',
    'safety_card_shown',
    // 안전 카드의 전화 누름(지표 화면 DEV-15 · D116). props 는 { number } 만
    'safety_call_tap',
    // 상회칠판 (SPEC_CHANGE_v1.3 17.6, D52)
    'board_open',
    'board_tab',
    'board_past_open',
    'board_schedule_seen',
];

/**
 * 화면이 POST /api/events 로 보낼 수 있는 이름. 나머지는 서버가 직접 남기는 것이라 화면에서 받지 않습니다
 * (화면이 서버 지표를 흉내 내지 못하게)
 */
export const CLIENT_EVENT_NAMES = [
    'app_open',
    'app_active',
    'memo_open',
    'safety_card_shown',
    'safety_call_tap',
    'board_open',
    'board_tab',
    'board_past_open',
    'board_schedule_seen',
    'last_seen_line_shown',
    'about_user_seen',
    'chip_shown',
    'chip_dismissed',
    'mention_open',
    'mention_pick',
    'message_send',
    'note_add_open',
    'member_card_open',
    // 프로필 「해 준 얘기」에서 다시 봄(DS-5 화면이 오면)
    'deep_story_reopen',
];

const CLIENT_NAME_SET = new Set(CLIENT_EVENT_NAMES);

export function isClientEventName(name) {
    return CLIENT_NAME_SET.has(name);
}

const NAME_SET = new Set(EVENT_NAMES);

export function isEventName(name) {
    return NAME_SET.has(name);
}
